<template>
  <b-container fluid id="partners" class="page">
    <div
      class="title d-flex justify-content-between align-items-center flex-wrap"
    >
      <h1>Partners</h1>
    </div>

    <div v-if="this.partners.length !== 0" id="partners-container">
      <div v-for="type in this.partners" :key="type.index">
        <h2>{{ type[0].type }}</h2>

        <ul class="partners-list">
          <li class="list-item" v-for="item in type" v-bind:key="item.name">
            <span class="item-square">
              <font-awesome icon="square" />
            </span>
            <a
              v-if="item.url"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
              class="links"
              >{{ item.name }}</a
            >
            <div v-else>{{ item.name }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else id="no-data" class="d-flex">
      <span><font-awesome icon="exclamation" fixed-width/></span>
      <p>No partners found!</p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Partners",
  props: ["page"],
  created() {
    // this.page = data
    let lookup = {};
    for (var partner, i = 0; (partner = this.page.get_partners[i++]); ) {
      let type = partner.type;

      if (!(type in lookup)) {
        lookup[type] = 1;
        this.types.push(type);
      }
    }

    for (let i = 0; i < this.types.length; i++) {
      this.partners.push(
        this.page.get_partners.filter(
          function(partner) {
            return partner.type == this.types[i];
          }.bind(this)
        )
      );
    }

    for (let i = 0; i < this.partners.length; i++) {
      if (this.partners[i].length === 0) {
        this.partners.splice(i, 1);
      }
    }

    for (let i = 0; i < this.partners.length; i++) {
      this.partners[i] = this.partners[i].filter((p) => p.vcmi);

      this.partners[i].sort((p1, p2) =>
        p1.name < p2.name ? -1 : p1.name > p2.name ? 1 : 0
      );
    }
  },
  data: function() {
    return {
      types: [],
      partners: [],
    };
  },
};
</script>

<style lang="scss">
#partners {
  #partners-container > div {
    margin-top: 3em;
  }

  h2 {
    color: $secondary-color;
  }

  .list-item {
    display: flex;

    justify-content: flex-start;

    .links {
      line-height: 100% !important;
    }
  }
}
</style>
